export var KursigeSettlementStatusEnum;
(function (KursigeSettlementStatusEnum) {
    KursigeSettlementStatusEnum["ACTIVE"] = "ACTIVE";
    KursigeSettlementStatusEnum["AWAITING_PAYMENT"] = "AWAITING_PAYMENT";
    KursigeSettlementStatusEnum["PAID_BY_MERCHANT"] = "PAID_BY_MERCHANT";
    KursigeSettlementStatusEnum["FULLY_SETTLED"] = "FULLY_SETTLED";
})(KursigeSettlementStatusEnum || (KursigeSettlementStatusEnum = {}));
//# sourceMappingURL=kursige-settlement-status.enum.js.map